<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-10-24 17:18:24
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-29 15:24:55
-->
<template>
  <v-btn :rounded='rounded'
         :color="color"
         class="primary--text"
         :text='textstatus'
         v-on="$listeners"
         v-bind="$attrs">
    <v-icon left
            v-if="left"
            :style="{'font-size':iconsize+'px'}"
            class="material-icons">add</v-icon>
    <!--   :style="{fontSize:textsize+'px'}" -->
    <span class="text-button">
      {{text}}
    </span>
    <v-icon right
            v-if="!left"
            :style="{'font-size':iconsize+'px'}"
            class="material-icons">add</v-icon>
  </v-btn>
</template>

<script> 
// depressed
export default {
  components: {},
  props: {
    textstatus: { type: Boolean, default: true },
    left: { type: Boolean, default: false },//默认加号在右边
    color: { type: String, default: 'primary' },
    text: { type: String, },
    iconsize: { type: String, default: '' },
    textsize: { type: String, default: '16' },
    rounded: { type: Boolean, default: true }
  },
  data () {
    return {
    };
  },
  created () { },
  mounted () { },
  methods: {
  },
  computed: {},
  watch: {},
};
</script> 

<style scoped>
</style>
